import React, { useEffect, useState } from 'react'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import Button from "@material-ui/core/Button"
import { FormControl } from '@material-ui/core'
import Container from '@material-ui/core/Container'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import DataTable from 'react-data-table-component'
import Input from '@material-ui/core/Input'
import GetAppIcon from '@material-ui/icons/GetApp'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import Link from '@material-ui/core/Link'
import MoreVert from '@material-ui/icons/MoreVert'
import Divider from "@material-ui/core/Divider"
import Popover from 'antd/lib/popover'
import { TelematicsStyles } from '../TelematicsStyles'
import { useTranslation } from 'react-i18next'
import { connect } from "react-redux"
import { bindActionCreators } from 'redux'
import * as navigationActions from '../../../actions/common/NavigationActions'
import * as TelematicsActions from '../../../actions/telematics/TelematicsActions'
import { customStyleSecondary } from '../../common/CommonStyles'
import Modal from 'antd/es/modal'
import UseForm from '../../common/UseForm'
import { useHistory } from 'react-router-dom'
import { Backdrop, CircularProgress, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core'
import InboxIcon from "@material-ui/icons/Inbox"

const ServiceInvoice = ({ classes, ...props }) => {
    const { t } = useTranslation();
    const history = useHistory();
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [serviceId, setServiceId] = useState(undefined);
    const paginationOptions = { rowsPerPageText: t('commonMessages.rowsPerPage'), rangeSeparatorText: t('common.to'), selectAllRowsItem: true, selectAllRowsItemText: t('common.all') };
    const [uploadedFiles, setUploadedFiles] = useState(false);
    const [uploadedFileExcel, setUploadedFileExcel] = useState(undefined);

    const initialFieldValues = {
        //orderNumber: parseInt(params.instalationId),
        pdf: {},
        xml: {},
        excel: {}
    }

    const {
        values,
        handleInpuFileChange
    } = UseForm(initialFieldValues)

    useEffect(() => {
        handleOpenBackdrop()

        props.actions.fecth_Installation_Order_Detail(props.userLanguage, props.userToken, props.match.params.branchOfficeId, props.match.params.instalationId, onError, onSuccess)
        let isViatic = false
        props.actions.fetch_Excel_Documents(props.userLanguage, props.userToken, props.match.params.instalationId, isViatic, onError, onSuccess)
        return () => {

        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (serviceId !== undefined) {
            props.actions.fetch_Invoice_Service_Documents(props.userLanguage, props.userToken, serviceId, onError, onSuccess)
        }
    }, [serviceId]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (Object.keys(values.xml).length !== 0 && Object.keys(values.pdf).length !== 0) {
            setUploadedFiles(true)
        } else {
            setUploadedFiles(false)
        }
    }, [values]) // eslint-disable-line react-hooks/exhaustive-deps

    //*First Render Functions
    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }

    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }

    const onSuccess = () => {
        handleCloseBackdrop()
    }

    const onSuccessDelete = (response) => {
        handleCloseBackdrop()
        props.actions.fetch_Invoice_Service_Documents(props.userLanguage, props.userToken, serviceId, onError, onSuccess)
        Modal.success({
            title: t('commonMessages.deletedSucc')
        })
    }

    const onSuccessSave = (response) => {
        handleCloseBackdrop()
        if (response.status) {
            Modal.success({
                title: t('commonMessages.savedSucc')
            })
            Array.from(document.querySelectorAll("input")).forEach(
                input => (input.value = ""))
            props.actions.fetch_Invoice_Service_Documents(props.userLanguage, props.userToken, serviceId, onError, onSuccess)
        }
        else {
            Modal.error({
                title: 'Error',
                content: t('commonMessages.alertInvoiceInvalid')
            })
        }
    }

    const onSuccessSaveExcel = (response) => {
        handleCloseBackdrop()
        if (response.status) {
            Modal.success({
                title: t('commonMessages.savedSucc')
            })
            Array.from(document.querySelectorAll("input")).forEach(
                input => (input.value = ""))
            setUploadedFileExcel(undefined)
        }
        else {
            Modal.error({
                title: 'Error',
                content: t('commonMessages.alertInvoiceInvalid')
            })
        }
    }

    //*Funtions Error & Navigation
    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 400:
                    Modal.error({
                        title: 'Error',
                        content: t(`telematicsErrors.${err.response.data.errors.ErrorCodes[0]}`)
                    })
                    break
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    Modal.error({
                        title: 'Error',
                        content: <Typography variant="body1" style={{ fontWeight: 600 }}>{t('commonMessages.alert500')}</Typography>
                    })
                    break
                default:
                    break
            }
        }
    }

    // *Check File Types
    const checkFileTypePDF = event => {
        let file = event.target.files[0]
        if (file != null) {
            let types = ['application/pdf']

            if (types.every(type => file.type !== type)) {
                Modal.error({
                    title: 'Error',
                    content: t('commonMessages.unsupportedFormat')
                })
                event.target.value = null
                return false
            } else {
                handleInpuFileChange(event)
            }
        }
    }

    const checkFileTypeXML = event => {
        let file = event.target.files[0]
        if (file != null) {
            let types = ['text/xml', 'application/xml']

            if (types.every(type => file.type !== type)) {
                Modal.error({
                    title: 'Error',
                    content: t('commonMessages.unsupportedFormat')
                })
                event.target.value = null
                return false
            } else {
                handleInpuFileChange(event)
            }
        }
    }

    const checkFileTypeXLS = event => {
        let file = event.target.files[0]
        if (file != null) {
            let types = ['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']

            if (types.every(type => file.type !== type)) {
                Modal.error({
                    title: 'Error',
                    content: t('commonMessages.unsupportedFormat')
                })
                event.target.value = null
                return false
            } else {
                return true
            }
        }
    }

    const handleSubmit = e => {
        if (uploadedFiles) {
            e.preventDefault()
            handleOpenBackdrop()

            const formData = new FormData()
            formData.append('ServiceNumber', serviceId)

            for (let file of values.pdf) {
                formData.append("pdf", file);
            }
            for (let file of values.xml) {
                formData.append("xml", file);
            }
            props.actions.update_Invoice_Service(props.userLanguage, props.userToken, formData, onError, onSuccessSave)
        } else {
            Modal.error({
                title: 'Error',
                content: t('commonMessages.errorUndefined')
            })
        }
    }

    const onChangeHandlerExcel = event => {
        if (checkFileTypeXLS(event)) {
            setUploadedFileExcel(event.target.files[0])
        }
    }

    const handleSubmitExcel = e => {
        console.log(uploadedFileExcel)
        if (uploadedFileExcel !== undefined) {
            e.preventDefault()
            handleOpenBackdrop()

            const formData = new FormData()
            formData.append('orderNumber', props.match.params.instalationId)
            formData.append("excel", uploadedFileExcel);

            props.actions.Upload_Excel_Invoice_To_Services(props.userLanguage, props.userToken, formData, onError, onSuccessSaveExcel)
        } else {
            Modal.error({
                title: 'Error',
                content: t('commonMessages.errorUndefined')
            })
        }
    }

    const handleDownload = (documentId) => {
        let isService = true
        props.actions.download_Viatic_Document(props.userLanguage, props.userToken, documentId, isService, onError)
    }

    const handleDownloadExcel = (documentId) => {
        let isService = false
        props.actions.download_Viatic_Document(props.userLanguage, props.userToken, documentId, isService, onError)
    }

    const handleDelete = (documentId) => {
        handleOpenBackdrop()
        props.actions.delete_Service_Document(props.userLanguage, props.userToken, serviceId, documentId, onError, onSuccessDelete)
    }

    const invoiceColumnsServices = [
        {
            name: t('telematicsDetail.fileName'),
            selector: 'fileName',
            width: '400px',
            sortable: true,
            cell: row => row.fileName
        },
        {
            name: t('telematicsDetail.registerDate'),
            selector: 'createDate',
            width: '400px',
            sortable: true,
            cell: row => row.createDate
        },
        {
            name: "",
            center: true,
            cell: row => (buttonForInvoiceColumns(row))
        },
        {
            center: true,
            omit: true,
            cell: row => row.supplierServiceID
        }
    ]

    const buttonForInvoiceColumns = (row) => {
        return (
            <div>
                <Tooltip title={t('common.download')}>
                    <IconButton style={{ color: '#82C341' }} onClick={() => handleDownload(row.id)}>
                        <GetAppIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title={t('common.delete')}>
                    <IconButton style={{ color: '#BF2E2E' }} onClick={() => handleDelete(row.id)}>
                        <DeleteForeverIcon />
                    </IconButton>
                </Tooltip>
            </div>
        )
    }

    const serviceColumns = [
        {
            name: t('telematicsDetail.serviceNumber'),
            selector: 'serviceRequestId',
            width: '525px',
            sortable: true,
            cell: row => row.serviceRequestId
        },
        {
            name: t('common.service'),
            selector: 'type_service',
            width: '525px',
            sortable: true,
            cell: row => row.type_service
        },
        {
            name: "",
            center: true,
            cell: row => (buttonForErrorColumns(row))
        },
        {
            center: true,
            omit: true,
            cell: row => row.supplierServiceID
        }
    ]

    const buttonForErrorColumns = (row) => {
        return (
            <div>
                <Popover
                    title=""
                    placement="bottomRight"
                    trigger="click"
                    content={
                        <div>
                            <div>
                                <Link onClick={() => setServiceId(row.serviceRequestId)}>
                                    {t('telematicsDetail.uploadInvoice')}
                                </Link>
                            </div>
                        </div>
                    }>
                    <IconButton>
                        <MoreVert />
                    </IconButton>
                </Popover>
            </div>
        )
    }

    return (
        <Container className={classes.generalBorder}>
            <Backdrop className={classes.backdrop} open={openBackdrop}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <br />
            {
                serviceId === undefined
                    ?
                    <Grid container >
                        <Grid item xs={12}>
                            <Typography variant="body1" style={{ fontWeight: 600 }}>{t('telematicsDetail.numberOrderInstalation')}</Typography>
                            <Typography variant="body1" >{props.match.params.instalationId}</Typography>
                        </Grid>
                        <Grid item xs={12}><br /></Grid>
                        <Grid container>
                            <Grid item xs={6}>
                                <FormControl fullWidth >
                                    <Grid item xs={5}><Typography variant="body1" style={{ fontWeight: 600 }}>{t('telematicsDetail.invoiceDetails')}</Typography></Grid>
                                    <Typography variant="body2">{t('collateralDetails.xlsFile')}</Typography>
                                    <Input
                                        fullWidth
                                        type="file"
                                        name="excel"
                                        onChange={onChangeHandlerExcel}
                                        className="fileXLS"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} className={classes.buttonAlign}>
                                <br /><br />
                                <Button variant="outlined" onClick={handleSubmitExcel} className={classes.generalBorder}>{t('common.save')}</Button>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}><br /></Grid>
                        <Grid container>
                            <Grid item xs={12}>
                            <List component="nav">
                                {
                                    props.listExcelDocuments && props.listExcelDocuments.map((item, index) => (
                                        <ListItem key={index} button onClick={() => handleDownloadExcel(item.id)}>
                                            <ListItemIcon>
                                                <InboxIcon />
                                            </ListItemIcon>
                                            <ListItemText primary={`${item.fileName} `} />
                                        </ListItem>
                                    ))
                                }
                            </List>
                        </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <br />
                            <DataTable
                                columns={serviceColumns}
                                defaultSortField="installationOrderId"
                                customStyles={customStyleSecondary}
                                data={props.installationDetail.installationOrderServicesListDto}
                                highlightOnHover
                                pointerOnHover
                                noHeader
                                dense
                                responsive
                                striped
                                pagination
                                paginationComponentOptions={paginationOptions}
                                noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>}
                            />
                            {
                                props.installationDetail.installationOrderServicesListDto && props.installationDetail.installationOrderServicesListDto.length < 1 && (
                                    <Grid container item xs={12}><br /></Grid>
                                )
                            }
                        </Grid>
                    </Grid>
                    :
                    <div>
                        <Grid container >
                            <Grid item xs={5}>
                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('telematicsDetail.numberOrderInstalation')}</Typography>
                                <Typography variant="body1" >{props.match.params.instalationId}</Typography>
                            </Grid>
                            <Grid item xs={1}><br /></Grid>
                            <Grid item xs={6}>
                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('telematicsDetail.numberService')}</Typography>
                                <Typography variant="body1" >{serviceId}</Typography>
                            </Grid>
                        </Grid>
                        <br />
                        <Grid container >
                            <Grid item xs={5}>
                                <FormControl fullWidth >
                                    <Typography variant="body2">{t('collateralDetails.xmlFile')}</Typography>
                                    <Input
                                        fullWidth
                                        type="file"
                                        name="xml"
                                        onChange={checkFileTypeXML}
                                        className="fileXML"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={1}><br /></Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth >
                                    <Typography variant="body2">{t('collateralDetails.pdfFile')}</Typography>
                                    <Input
                                        fullWidth
                                        type="file"
                                        name="pdf"
                                        onChange={checkFileTypePDF}
                                        className="filePDF"
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <br />
                        <Grid container direction="row" justify="space-between" alignItems="flex-end">
                            <Grid item xs={8}><br /></Grid>
                            <Grid item xs={2} className={classes.buttonAlign}>
                                <Button onClick={() => setServiceId(undefined)} variant="outlined" className={classes.generalBorder}>{t('common.return')}</Button>
                            </Grid>
                            <Grid item xs={2} className={classes.buttonAlign}>
                                <Button variant="outlined" className={classes.generalBorder} onClick={handleSubmit}>{t('common.upload')}</Button>
                            </Grid>
                        </Grid>

                        <Grid item xs={12}><br /></Grid>
                        <Divider />
                        <Grid item xs={12}><br /></Grid>

                        <Grid container  >
                            <DataTable
                                noHeader
                                columns={invoiceColumnsServices}
                                data={props.listInvoiceServiceDocuments}
                                defaultSortField="installationOrderId"
                                customStyles={customStyleSecondary}
                                highlightOnHover
                                dense
                                responsive
                                striped
                                pointerOnHover
                                pagination
                                paginationComponentOptions={paginationOptions}
                                subHeader={false}
                                noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>}
                            />
                            {
                                props.listInvoiceServiceDocuments && props.listInvoiceServiceDocuments.length < 1 && (
                                    <Grid container item xs={12}><br /></Grid>
                                )
                            }
                        </Grid>
                    </div>
            }
        </Container>
    )
}

const mapStateToProps = state => ({
    installationDetail: state.TelematicsReducer.installationOrderDetail,
    listInvoiceServiceDocuments: state.TelematicsReducer.listInvoiceServiceDocuments,
    listExcelDocuments: state.TelematicsReducer.listExcelDocuments,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(TelematicsActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(TelematicsStyles)(ServiceInvoice))